import React from 'react';
import SetupAccountsStep from 'components/AccountConnectionFlow/SetupAccountsStep';

const SetUpGoogleAdsAccountsStep = () => {
  return <SetupAccountsStep />;
};

export default SetUpGoogleAdsAccountsStep;
